module.exports = __webpack_public_path__ + "media/images/social-icons/vero-white-96d204e8e98ae9c7ddf48b216f6179bf.svg";